import React from "react";
import Title from '../../Common/Childs/Structure/Title';

export default function Description() {

    return (
        <div className="welcome-card px-5 py-5 mb-5">
            <p className="desc-text text-gray">Welcome to Fund Raisin's Creator Tools! Use these tools to create your very own Fund Raisin campaigns and art. If you want to sponsor a Fund Raisin campaign or are an artist who wants to create art for Fund Raisin NFTs, these tools are for you.</p>
        </div>
    )

}